import httpClient from 'hub-http/clients/apiClient';
import { createRpcClientV1 } from 'rpc-client-utils';
const rpcClient = createRpcClientV1({
  hubHttpClient: httpClient
});
export default rpcClient;